import loaderImage from 'assets/loader.gif';

import styles from './Loader.module.scss';

export const Loader = () => {
  return (
    <div className={styles.LoaderWrapper}>
      <div className={styles.Loader} style={{ backgroundImage: `url(${loaderImage})` }} />
    </div>
  );
};
